import React from 'react';
import './DashboardHeader.css';

export const DashboardHeader = () => {
  return (
    <div className='dashboard_header'>
      <p>Perfil</p>
      <p>Apellidos</p>
      <p>Nombres</p>
      <p>Correo</p>
      <p>Cantidad de reportes</p>
      <p>Estado Usuario</p>
      <p>Conf. cambios</p>
    </div>
  )
}
